import React from 'react';
import { Search, X } from 'lucide-react';
import type { Tab } from '../../types';

type TabNavigationProps = {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
};

export function TabNavigation({
  tabs,
  activeTab,
  onTabChange,
  searchQuery,
  onSearchChange,
}: TabNavigationProps) {
  return (
    <nav className="mb-4 bg-background pt-4">
      <div className="flex justify-end mb-3">
        <div className="relative w-full md:w-auto">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <input
            type="text"
            placeholder="Search tabs..."
            value={searchQuery}
            onChange={e => onSearchChange(e.target.value)}
            className={`w-full md:min-w-[200px] pl-10 pr-3 py-2 text-sm border rounded-md focus:outline-none bg-transparent dark:bg-gray-800 dark:text-white ${
              searchQuery.trim()
                ? 'border-blue-500 ring-2 ring-blue-200 dark:ring-blue-800 focus:ring-blue-500 focus:border-blue-500'
                : 'border-gray-300 dark:border-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            }`}
          />
          {searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
        {tabs.map(tab => {
          const isActive = activeTab === tab.id && !searchQuery.trim();
          return (
            <button
              key={tab.id}
              onClick={() => {
                onTabChange(tab.id);
                onSearchChange('');
              }}
              className={`flex items-center px-4 py-2 rounded-md font-medium text-sm whitespace-nowrap transition-all ${
                isActive
                  ? 'bg-black dark:bg-blue-600 text-white'
                  : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

    </nav>
  );
};
